<script>
  import { inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';

  let { calendars = [] } = $props();
</script>

<AppLayout title="Calendars">
  <div class="flex justify-end mb-6">
    <Button href="/calendars/new"><Icon icon="mdi:plus" class="mr-1" /> New calendar</Button>
  </div>

  {#if calendars.length === 0}
    <Card>
      <div class="text-center py-8">
        <Icon icon="mdi:calendar-multiple" class="text-4xl text-secondary-300 mx-auto mb-3" />
        <p class="text-secondary-500 mb-4">No calendars yet. A calendar groups social accounts that belong to the same entity.</p>
        <Button href="/calendars/new">Create your first calendar</Button>
      </div>
    </Card>
  {:else}
    <div class="flex flex-col gap-3">
      {#each calendars as calendar}
        <a use:inertia href={`/calendars/${calendar.id}`} class="card !p-5 hover:border-primary-200 flex items-center justify-between gap-4">
          <div class="flex items-center gap-3">
            <Icon icon="mdi:calendar-multiple" class="text-secondary-400 text-xl" />
            <span class="text-secondary-800 font-medium">{calendar.name}</span>
          </div>
          <span class="text-sm text-secondary-500">{calendar.account_count} {calendar.account_count === 1 ? 'account' : 'accounts'}</span>
        </a>
      {/each}
    </div>
  {/if}
</AppLayout>
